export const MAX_UNPAID_WISHLIST_ITEMS = 3;